//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import { axiosGet } from '../../../axios/axios.js'

import DispatcherTasksTabSelectExecutor from '../../pages/main/sections/Dispatcher/DispatcherTab/DispatcherTasksTabSelectExecutor.vue'
import ItemsSearchField from '../../components/Field/ItemsSearchField.vue'
import { createFieldConfig, Store } from '../../components/QSelectUtils.js'

export default {
  components: {
    ItemsSearchField
  },
  props: {
    request: {
      type: Object,
      required: true
    }
  },
  data: function () {
    return {
      executionConfiguration: {
        appointmentDispatcher: {
          value: null,
          label: 'Диспетчер, назначивший исполнителя',
          fieldConfig: this.createExecutorFieldConfig('dispatcher')
        },
        reportChecker: {
          value: null,
          label: 'Аналитик, проверивший отчёт',
          fieldConfig: this.createExecutorFieldConfig('reportchecker')
        },
        closureDispatcher: {
          value: null,
          label: 'Диспетчер, закрывший заявку',
          fieldConfig: this.createExecutorFieldConfig('dispatcher')
        }
      },

      brigadeSelection: null,
      appointmentConfig: null
    }
  },
  computed: {
    taskStatus: function () {
      return this.request.bpStateId
    },
    beforeAppointment: function () {
      return this.taskStatus === 'BS1' || this.taskStatus === 'BS2'
    },
    reportExecutorName: function () {
      return this.brigadeSelection ? this.brigadeSelection.name || 'Исполнитель без названия' : ''
    }
  },
  watch: {
  },
  created: function () {
  },
  methods: {
    getConfig: function () {
      const executionConfiguration = this.executionConfiguration

      const config = {
        appointmentDispatcher: { id: executionConfiguration.appointmentDispatcher.value.id },
        reportChecker: { id: executionConfiguration.reportChecker.value.id },
        closureDispatcher: { id: executionConfiguration.closureDispatcher.value.id },
        appointmentConfig: this.appointmentConfig
      }
      return config
    },
    onApply: function () {
      const config = this.getConfig()
      this.$emit('confirm', config)
    },
    onCancel: function () {
      this.$emit('cancel')
    },

    // ---

    createExecutorFieldConfig: function (role) {
      const request = this.request
      return createFieldConfig(new Store({
        fullReadable: false,
        searchable: true,
        searchFiltrationBySource: true,
        searchValueMinLength: 0,
        cached: false,
        proxy: {
          urlBase: '/service/delta/requestBusinessProcess/special/searchAutoCompletionEmployees',
          searchParamKey: 'name',
          // filterType: 'stock',
          // formId: 'stockInventoryTask',
          get urlParams () {
            const params = {}
            params.request = request.requestId || null
            params.role = role
            return params
          }
        }
      }))
    },

    // ---

    onSelectReportExecutor: async function () {
      if (this.beforeAppointment) {
        const brigadeSelection = await this.selectAutoCompleteBrigade()
        if (!brigadeSelection) {
          return
        }

        const appointmentConfig = {
          brigadeId: brigadeSelection.brigadeId,
          ignoreEndWorkTime: true,
          workDate: brigadeSelection.workDateMillis,
          workShift: brigadeSelection.workShift,
          // requests
          append: true
        }

        this.brigadeSelection = brigadeSelection
        this.appointmentConfig = appointmentConfig
      }
    },

    selectAutoCompleteBrigade: function () {
      return new Promise((resolve, reject) => {
        const dialog = this.$d.dialog(this).show({
          maximizedOnNarrow: true,
          persistent: true,
          noWrap: true,
          contentWidth: 560,
          contentComponent: DispatcherTasksTabSelectExecutor,
          contentProps: {
            opened: true,
            updateOnOpen: true,
            selectedRequestsIds: this.request.requestId ? [this.request.requestId] : [],
            singleRequest: this.request,
            selectMode: true
          },
          componentHandlers: {
            close: () => {
              dialog.hide()
              resolve(null)
            },
            select: (brigadeSelection) => {
              dialog.hide()
              resolve(brigadeSelection)
            }
          }
        })
      })
    }
  }
}
